import { useTranslation } from 'react-i18next'
import ContactForm from '../components/ContactForm'
import LibertinsHome from '../components/announces-libertins'
import HomeFilter from '../components/HomeFilter'

export default function LibertinsPage() {
  const { t } = useTranslation()
  return (
    <>
      <div
        id='premium-slider'
        className='text-center w-full pt-3 align-middle bg-redpink text-white  py-3'
      >
        <p className='uppercase text-lg lg:text-2xl'>
          {t('libertines-corner')}
        </p>
        <p className='text-sm lg:text-base text-white/90'>
          {t('libertines-corner-desc')}
        </p>
      </div>
      <div
        id='home-filter'
        className='w-full mx-auto justify-center text-anthracite'
      >
        <HomeFilter />
      </div>
      <div
        id='announces-home'
        className='w-full  mx-auto justify-center text-anthracite'
      >
        <LibertinsHome />
      </div>
      <ContactForm />
    </>
  )
}
